import http from '../shared/http'
import { IGroupSet, ITaskGroup } from '../types/tasks.types'

const getSetsGroups = async (setIds: Array<IGroupSet['id']>): Promise<ITaskGroup[]> => {
  return http.get(`/api/v1/admin/exercise_groups/?set__in=${setIds.join(',')}&limit=1000`).then((r) => r.data.results)
}

const createGroup = async (setId: string, premium: boolean, orderingIndex = undefined): Promise<ITaskGroup> => {
  return http.post('/api/v1/admin/exercise_groups/', { premium, set: setId, orderingIndex }).then((r) => r.data)
}

const updateGroup = async (groupId: ITaskGroup['id'], updates: Partial<ITaskGroup>): Promise<ITaskGroup> => {
  return http.patch('/api/v1/admin/exercise_groups/' + groupId + '/', updates).then((r) => r.data)
}

const groupsService = { createGroup, getSetsGroups, updateGroup }
export default groupsService
